"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Icon_1 = require("../Icon");
var Component = function (props) {
    var classes = 'form-text invalid-feedback';
    if (props.forceVisible) {
        classes += ' d-block';
    }
    return (React.createElement("p", { id: props.id + "-errormessage", className: classes, tabIndex: -1, ref: props.forwardRef },
        React.createElement(Icon_1.Icon, { symbol: "messageAlert16", children: props.message, type: props.iconType })));
};
Component.displayName = 'ErrorMessage';
Component.defaultProps = {
    iconType: 'svgfile',
};
Component.propTypes = {
    forceVisible: PropTypes.bool,
    id: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};
exports.ErrorMessage = React.forwardRef(function (props, ref) {
    var attributes = __assign({}, props);
    if (ref) {
        attributes.forwardRef = ref;
    }
    return (React.createElement(Component, __assign({}, attributes)));
});
exports.ErrorMessage.displayName = 'ErrorMessage';
